export const TRANSLATIONS_SP = {
  HELLO_DEALER: '¡Hola Concesionario!',
  SEND_ALERT_MODAL_TITLE: 'Subir archivo CSV',
  ADD_EDIT_OFFERS_TIPS_MODAL_TITLE: 'Subir archivo',
  POSTER_SUBTITLE:
    'Nuestra misión es que los concesionarios ofrezcan a sus clientes la mejor experiencia',
  DEALER_KER: 'DEALERKER',
  SIGN_IN: 'Iniciar sesión',
  SIGN_IN_SUBTITLE: 'Inicia sesión para permanecer conectado',
  EMAIL: 'Email',
  PASSWORD: 'Contraseña',
  ENTER_USERNAME: 'Introduce tu nombre de usuario',
  ENTER_PASSWORD: 'Introduce tu contraseña',
  PLEASE_ENTER_USERNAME: 'Por favor, introduce tu nombre de usuario',
  PLEASE_ENTER_PASSWORD: 'Por favor, introduce tu contraseña',
  SOMETHING_WENT_WRONG: 'Algo ha ido mal',
  FORGOT_PASSWORD: 'He olvidado mi contraseña',
  PLEASE_ENTER_EMAIL: 'Por favor, intruduce tu email',
  PLEASE_ENTER_VALID_EMAIL: 'Por favor, valida tu email',
  VEHCILE: 'Vehículos',
  LOADING: 'Cargando',
  FORGOT_PASSWORD_SUBTITLE:
    'Introduce tu dirección de email y te enviaremos un correo electrónico con instrucciones para restablecer la contraseña',
  ENTER_EMAIL: 'Introduce tu email',
  SEND_LINK: 'Enviar enlace',
  SUCCESS: '¡Éxito!',
  FORGOT_PASSWORD_SUCCESS_SUBTITLE:
    'Se ha enviado un mensaje a tu dirección de email. Verifícalo y haz click en el enlace para restablecer tu contraseña',
  BACK_TO_HOME: 'Vuelve al inicio',
  FORGOT_PASSWORD_SUCCESS_MESSAGE: 'Tu nueva contraseña ha sido enviada a tu dirección de email',
  RESET_PASSWORD: 'Restablecer la contraseña',
  RESET_PASS_SUBTITLE:
    'Introduce tu nueva contraseña para restablecerla. Te pediremos esta contraseña cada vez que inicies sesión',
  PASS_VALIDATION_1:
    'Debe tener al menos una minúscula, una mayúscula, un número y un carácter especial',
  PASS_VALIDATION_2: 'Debe contener al menos 8 caracteres',
  CONFIRM_PASSWORD: 'Confirmar contraseña',
  RESET_PASS_SUCCESS_MESSAGE:
    'Tu nueva contraseña se ha restablecido con éxito. ahora puedes acceder a tu cuenta con tu nueva contraseña',
  RESET_PASSWORD_SUCCESS_TOAST: 'Contraseña restablecida con éxito',
  RESET_PASSWORD_ERROR_MESSAGE_1:
    'Por favor, introduce una contraseña válida. La contraseña debe tener al menos una minúscula, una mayúscula, un número y un carácter especial. Longitud mínima de 8 caracteres y longitud máxima de 30 caracteres',
  RESET_PASSWORD_ERROR_MESSAGE_2: 'La contraseña y la confirmación de la contraseña no coinciden',
  ADD_VEHICLE: 'Agregar vehículo',
  Edit_VEHICLE: 'Editar vehículo',
  ADD_VEHICLE_SUBTITLE: 'Completa la siguiente información para agregar un nuevo vehículo',
  EDIT_VEHICLE_SUBTITLE: 'Completa la siguiente información para editar un nuevo vehículo',
  ASSIGNED_USER: 'Usuario asignado',
  ASSOCIATED_COMPANY: 'Empresa asociada',
  TIRE_SIZE_PLACEHOLDER: 'Introduce la medida del neumático',
  ADD_TIRE_SIZE: 'Agregar medida de neumático',
  ERROR_TIRE_SIZE_TOAST_MESSAGE: 'Por favor, introduce la medida del neumático',
  SUCCESS_TIRE_SIZE_UPDATED_TOAST_MESSAGE:
    'La medida del neumático ha sido actualizada correctamente',
  SUCCESS_TIRE_SIZE_ADDED_TOAST_MESSAGE: 'La medida del neumático se ha agregada correctamente',
  EDIT_TIRE_SIZE: 'Editar la medida del neumático',
  SUCCESS_TIRE_SIZE_DELETED_TOAST_MESSAGE: 'La medida del neumático se ha suprimido correctamente',
  DELETE_TIRE_SIZE: 'Suprimir la medida del neumático',
  DELETE_TIRE_SIZE_MESSAGE: '{{nombre}}, Estás seguro que quieres suprimir la medida del neumático',
  TIRE_SIZE: 'Medida del neumático',
  CREATED_ON: 'Creado el',
  UPDATED_ON: 'Actualizado el',
  NODATA_TIRE_SIZE: 'No hay configurada ninguna medida de neumático todavía',
  EDIT: 'Editar',
  REMOVE: 'Eliminar',
  EDIT_MODEL: 'Editar modelo',
  SUCCESS_MODEL_DELETED_TOAST_MESSAGE: 'El modelo ha sido eliminado correctamente',
  DELETE_MODEL: 'Eliminar modelo',
  DELETE_MODEL_MESSAGE: '¿{{nombre}}, Estás seguro que quieres eliminar el modelo?',
  NODATA_MODEL_CREATED: 'No hay configurado ningún modelo todavía',
  EDIT_ENGINE: 'Editar motor',
  DELETE_ENGINE: 'Eliminar motor',
  DELETE_ENGINE_MESSAGE: '¿{{nombre}}, estás seguro que quieres eliminar el motor?',
  SUCCESS_ENGINE_DELETED_TOAST_MESSAGE: 'El motor ha sido eliminado correctamente',
  ENGINE: 'Motor',
  NODATA_ENGINE_CREATED: 'No hay configurado ningún motor todavía',
  EDIT_DEVICE: 'Editar dispositivo',
  DELETE_DEVICE: 'Eliminar dispositivo',
  DELETE_DEVICE_MESSAGE: '¿{{nombre}}, estás seguro que quieres eliminar el dispositivo?',
  SUCCESS_DEVICE_DELETED_TOAST_MESSAGE:
    'El Proveedor del dispositivo ha sido eliminado correctamente',
  EDIT_DEVICE_PROVIDER: 'Editar proveedor dispositivo',
  DELETE_DEVICE_PROVIDER: 'Eliminar proveedor dispositivo',
  DELETE_DEVICE_PROVIDER_MESSAGE:
    '¿{{nombre}}, estás seguro que quieres eliminar el proveedor del dispositivo?',
  SUCCESS_DEVICE_PROVIDER_DELETED_TOAST_MESSAGE:
    'El proveedor del dispositivo ha sido eliminado correctamente',
  NODATA_DEVICE_PROVIDER_CREATED: 'No hay configurado ningún proveedor de dispositivo todavía',
  EDIT_BRAND: 'Editar marca',
  DELETE_BRAND: 'Eliminar marca',
  DELETE_BRAND_MESSAGE: '¿{{nombre}}, estás seguro que quieres eliminar la marca?',
  SUCCESS_BRAND_DELETED_TOAST_MESSAGE: 'La marca ha sido eliminada correctamente',
  NODATA_BRAND_CREATED: 'No hay configurada ninguna marca todavía',
  ORGANIZATION_NAME: 'Nombre de la Organización',
  SAVE_SLOTS: 'Guardar citas de taller disponibles',
  REMOVE_SLOTS: 'Eliminar citas de taller disponibles',
  APPOINTMENT_DETAILS: 'Detalles de la cita de taller',
  AVAILABILITY_SLOTS: 'Disponibilidad de citas de taller',
  APPOINTMENT_DESCRIPTION: 'Descripción de la cita de taller',
  SUCCESS_SLOT_BOOK_TOAST_MESSAGE: 'La cita de taller se ha reservado con éxito',
  ERROR_SLOT_BOOK_TOAST_MESSAGE: 'Por favor, seleccione citas de taller disponibles',
  VEHICLE_BRAND: 'Marca del vehículo',
  DEALERBEST: 'DEALERBEST',
  MOBILE_NO: 'Móvil',
  FISCAL_ADDRESS: 'Dirección',
  VAT: 'CIF',
  PARKING: 'Sedes',
  COMPLETED: 'Completado',
  URL_PLACEHOLER: 'Introduce URL',
  ALERT: 'Alerta',
  BRAND: 'Marca',
  MODEL: 'Modelo',
  PLATE: 'Matrícula',
  STATUS: 'Estado',
  DETAILS: 'Detalles',
  SEARCH: 'Buscar',
  ADD_NEW_VEHCILE: 'Agregar nuevo vehículo',
  EXPORT_AS_DATA: 'Exportar datos',
  EXPORT_AS_TEMP: 'Exportar plantilla',
  EXPORT_VIN_TEMPLATE: 'Exportar plantilla de números de bastidor',
  VEHICLE_SEARCH_TOOLTIP_TEXT:
    'Buscar por Marca, Modelo, Matrícula, Chasis, Tipo, Versión y Usuario Asignado',
  ALERT_SEARCH_TOOLTIP_TEXT: 'Búsqueda por Nombre de cliente o Matrícula del cliente',
  PAYMENT_SEARCH_TOOLTIP_TEXT: 'Búsqueda por Placa, Modelo y email del Cliente.',
  EMPTY_VEHCILE_LIST_MESSAGE: 'No hay vehículos creados todavía',
  EMPTY_PAYMENT_LIST_MESSAGE: 'No hay pagos creados todavía',
  ORGANIZATION_NAME: 'Nombre de Organización',
  VEHICLE_FILTER_ERROR_MESSAGE_1:
    'La fecha de finalización del plazo de matriculación debe ser posterior a la fecha de inicio',
  VEHICLE_FILTER_ERROR_MESSAGE_2:
    'La fecha de finalización del plazo de compra debe ser posterior a la fecha de inicio',
  VEHICLE_FILTER_ERROR_MESSAGE_3:
    'Los kilómetros finales deben ser mayores que los kilómetros iniciales',
  CLEAR_FILTER: 'Borrar Filtros',
  FILTER_BY: 'Filtrar por',
  REG_FROM: 'Matriculación desde',
  REG_TO: 'Matriculación hasta',
  PUR_FROM: 'Compra desde',
  PUR_TO: 'Compra hasta',
  COMPANY: 'Empresa',
  ORGANIZATIONS: 'Organizaciones',
  ASS_COMPANIES: 'Empresas asociadas',
  TRANSMISSION: 'Transmisión',
  CATEGORY: 'Categoría',
  VEHI_TYPE: 'Tipo de Vehículo',
  ENGINE_TYPE: 'Tipo de Motor',
  FUEL_TYPE: 'Tipo de Combustible',
  FUEL_LEVEL: 'Nivel de combustible',
  FUEL_LEVEL_PERCENTAGE: 'Nivel de combustible (%)',
  FUEL_LEVEL_VOLUME: 'Nivel de combustible (Vol)',
  BATTERY_LEVEL: 'Nivel de batería',
  LAST_MONTH_AVERAGE: 'Promedio del último mes',
  LAST_UPDATED: 'Última actualización',
  DOORS: 'Puertas',
  PLACES: 'Plazas',
  ENV_LABLE: 'Distintivo ambiental',
  TIRE_SIZE: 'Medida de los Neumáticos',
  FRONT_TIRE_SIZE: 'Medida de los Neumáticos delanteros',
  REAR_TIRE_SIZE: 'Medida de los Neumáticos traseros',
  KM_FROM: 'KM desde',
  KM_TO: 'KM hasta',
  NEW_CAR_USED_CARS: 'Coches nuevos/Coches Usados',
  APPLY: 'Aplicar',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
  CONFIRM: 'Confirmar',
  USED_CARS: 'Coches Usados',
  NEW_CARS: 'Coches Nuevos',
  ADD_NEW_USER: 'Agregar nuevo Usuario',
  ADD_NEW_USER_SUBTITLE: 'Completa la siguiente información para agregar un nuevo usuario',
  PLEASE_SELECT_BRAND: 'Por favor, selecciona marca',
  PLEASE_ENTER_MODEL: 'Por favor, introduce modelo',
  PLEASE_SELECT_REG_DATE: 'Por favor, selecciona fecha de matriculación',
  PLEASE_SELECT_PUR_DATE: 'Por favor, selecciona fecha de compra',
  PLEASE_SELECT_ORG: 'Por favor, selecciona organización',
  PLEASE_SELECT_CAT: 'Por favor, selecciona categoría',
  PLEASE_SELECT_MODEL: 'Por favor, selecciona modelo',
  PLEASE_SELECT_PLATE: 'Por favor, selecciona matrícula',
  PLEASE_ENTER_VIN: 'Por favor selecciona número de bastidor',
  PLEASE_ENTER_TUTION: 'Please enter tution',
  PLEASE_ENTER_FRAME: 'Please enter frame',
  PLEASE_ENTER_ENGINE: 'Por favor, selecciona motor',
  PLEASE_SELECT_FUELTYPE: 'Por favor, selecciona tipo de combustible',
  PLEASE_SELECT_TRANSMISSION: 'Por favor, selecciona transmisión',
  PLEASE_SELECT_TIRE_SIZE: 'Por favor, selecciona medida de neumáticos',
  PLEASE_SELECT_FRONT_TIRE_SIZE: 'Por favor, selecciona medida de neumáticos delanteros',
  PLEASE_SELECT_REAR_TIRE_SIZE: 'Por favor, selecciona medida de neumáticos traseros',
  PLEASE_SELECT_STATUS: 'Por favor, selecciona estado',
  PLEASE_ENTER_KM: 'Por favor, selecciona kilómetros',
  PLEASE_ENTER_DEVICE_IMEI: 'Por favor, selecciona código IMEI de dispositivo',
  PLEASE_SELECT_DEVICE_PROVIDER: 'Por favor, selecciona proveedor de dispositivo',
  VEHCILE_UPDATE_SUCCESS_MESSAGE:
    'Las características del vehículo se han actualizado correctamente',
  VEHICLE_ADD_SUCCESS_MSG: 'El vehículo ha sido agregado con éxito',
  NO_IMG: 'No hay imagen',
  SELECT_MODEL: 'Selecciona modelo',
  REG_DATE: 'Fecha de matriculación',
  PUR_DATE: 'Fecha de compra',
  ORG_DETAILS: 'Detalles de la Organización',
  SELE_ORG: 'Por favor, selecciona Organización',
  ASSIGN_USR: 'Usuario asignado',
  OPTIONAL: 'Opcional',
  SELECT_ASSIGNED_USR: 'Selecciona usuario asignado',
  EMPTY_PARK_ADD_MSG: 'No hay sede agregada',
  PLEASE_SEL_ASS_COM: 'Por favor, selecciona empresa asociada',
  CAT_ORG: 'Categoría/Origen',
  SEL_CAT_ORG: 'Selecciona Categoría/Origen',
  SEL_TYPE: 'Selecciona tipo',
  TYPE: 'Tipo',
  ENTER_PLATE: 'Introduce matrícula',
  VIN: 'Número de bastidor',
  ENTER_VIN: 'Introduce Numero de Bastidor',
  KM: 'Kilómetros',
  ENTER_KM: 'Introduce kilómetros',
  SEL_ENGINE: 'Selecciona motor',
  SEL_TIRE_SIZE: 'Selecciona medida de neumáticos',
  SEL_REAR_TIRE_SIZE: 'Selecciona medida de neumáticos traseros',
  TUTION: 'Tution',
  ENTER_TUTION: 'Enter tution',
  FRAME: 'Frame',
  ENTER_FRAME: 'Enter frame',
  DEVICE: 'Dispositivo',
  PROVIDER_NAME: 'Nombre del proveedor',
  DEVICE_PROVIDER: 'Proveedor del dispositivo',
  SEL_DEVICE_PROVIDER: 'Selecciona proveedor de dispositivo',
  Device_IMEI: 'Código IMEI del dispositivo',
  ENTER_DEVICE_IMEI: 'Introduce Código IMEI del dispositivo',
  VERSION: 'Versión',
  ENTER_VERSION: 'Introduce versión',
  ENTER_DOORS: 'Introduce puertas',
  ENTER_PLACES: 'Introduce puertas',
  NEW_CAR_OR_USED_CAR: 'Coche nuevo o coche usado',
  SEL_ENV_LABEL: 'Selecciona etiqueta medioambiental',
  ORG: 'Organización',
  SAVE_CHANGES: 'Guardar cambios',
  ADDRESS_1: 'Dirección 1',
  PARKING_HEADQUATERS: 'Sucursal/Instalación principal',
  LAST_UPDATE_KM_DATE: 'Fecha de la última actualización de kilómetros',
  POLICY_EXP_DATE: 'Fecha vencimiento de la póliza de seguro',
  INS_POLICY_NO: 'Número de la póliza de seguro',
  DTC_ALERTS: 'DTC Alertas',
  dtc: {
    tableHeaders: {
      dtcCode: 'Código DTC',
      createdAt: 'Creado en',
      faultDescription: 'Descripción de la falla',
    },
  },
  VEHICLE_INFO: 'Información del vehículo',
  ALERTS: 'Alertas',
  APPOINTMENTS: 'Citas de taller',
  EDIT_DETAILS: 'Editar detalles',
  KM_Updated_AT: 'Kilómetros actualizados a día',
  NO_USERS: 'Número de usuarios',
  NOTIFY_USERS: 'Notificar a los usuarios',
  FILE_SIZE: 'Tamaño máximo del archivo : 25 MB',
  FILE_TITLE: 'Subir foto/vídeo',
  DATE_PLACEHOLDER: 'DD/MM/AAAA',
  CHOOSE_FILE: 'Selecciona Archivo',
  NO_FILE_CHOSEN: 'No hay archivo seleccionado',
  SEARCH_PLACEHOLDER: 'Escribe para buscar...',
  BACK_HOME: 'volver a inicio',
  CHECK_BACK_LATER: 'vuelve a intentarlo más tarde',
  WORK_IN_PROGESS: 'En proceso',
  LOADING: 'Cargando...',
  NO_OPTION: 'No hay opción',
  NO_RESULT_FOUND: 'No hay resultado',
  Notification: 'Notificación',
  NO_NOTIFICATION: 'No hay notificaciones',
  APPOINTMENT_REQUEST:
    'Tienes una nueva solicitud de cita de taller. Por favor, programa tu disponibilidad',
  ERROR_ACCESS_SLOT_AVAILIBILITY: 'No tienes permiso de acceso al calendario de citas disponibles.',
  ERROR_ACCESS_SLOT_CONFIRMATION:
    'No tienes permiso de acceso a la función de confirmación de citas..',
  LOGOUT: 'Cerrar sesión',
  PROFILE: 'Perfil',
  ACTIVE: 'Activo',
  EXPORT: 'Exportar',
  ADDRESS1: 'Dirección linea 1',
  ADDRESS2: 'Dirección linea 2',
  tips: 'Consejos',
  offer: 'Oferta',
  Active: 'Activo',
  completed: 'Completado',
  PAIT: 'Pagado',
  Canceled: 'Cancelado',
  not_paid: 'Sin pagar',
  alert: 'Alerta',
  PENDING: 'Pendiente',
  in_progress: 'En proceso',
  warning: 'Advertencia',
  super_admin: 'Super Administrador',
  sleep: 'Dormida',
  offer: 'Oferta',
  PAGE: 'Pagina',
  OF: 'de',
  SCHEDULED: 'Programado',
  SENT: 'Enviado',
  dealer_admin: 'Dealer Administrador',
  fleet_manager: 'Gestor de flota',
  call_center: 'Call Center',
  new_used_car: 'Coche Nuevo o Coche Usado',
  purchase_date: 'Fecha de compra',
  vin_number: 'Escribe número de bastidor para buscar...',
  appointments: {
    pageTitle: 'Citas de taller',
    tableHeaders: {
      dateAndTime: 'Fecha y hora de la cita de taller',
      serviceType: 'Tipo de servicio',
      description: 'Descripción',
      specialNotes: 'Anotaciones/Peticiones',
    },
    noDataMessage: 'Sin datos de la cita de taller',
  },

  mediaList: {
    tableHeader: {
      media: 'Foto/vídeo',
      type: 'Tipo',
      mediaBeforeService: 'Medios antes del servicio',
      mediaAfterService: 'Servicio posventa de medios',
    },
    noDataMessage: 'No hay archivos adjuntos disponibles.',
  },
  WORKSHOP_APPOINTMENTS_DETAILS: {
    title: 'Detalles de las citas del taller',
  },
  companies: {
    pageTitle: 'Empresas',
    searchPlaceholder: 'Buscar por nombre',
    primaryButtonLabel: 'Agregar Empresa',
    successCompanyDeletedToastMessage: 'Empresa eliminada correctamente.',
    noDataMessage: 'No hay ninguna empresa creada todavía',
    tableHeaders: {
      name: 'Nombre',
      fiscal_number: 'CIF',
      activity: 'Actividad',
      headquarters: 'Sede',
      other_stations: 'Otras oficinas secundarias',
    },
    editModel: {
      title: 'Editar empresa',
      subtitle: 'Completa la siguiente información para editar la empresa',
    },
    addModel: {
      title: 'Agregar Empresa',
      subtitle: 'Completa la siguiente información para agregar nueva empresa',
    },
    deleteModel: {
      title: 'Eliminar Empresa',
      message: `¿Estás seguro que quieres eliminar la empresa {{Nombre de la empresa}}?`,
    },
    add_edit: {
      headquarter_address: 'Dirección de la Sede',
      noaddressmessage: 'No se agregó la dirección de las oficinas',
      addressline: 'Dirección {{indice}}',
      save_changes: 'Guardar los cambios',
      add_station: 'Agregar Oficina secundaria',
      add_company: 'Agregar Empresa',
      postalCode: 'Código Postal',
      city: 'Ciudad',
      state: 'Comunidad Autonoma',
      country: 'País',

      name_message: 'Por favor, introduce nombre',
      fiscal_number_message: 'Por favor, introduce NIF/CIF',
      activity_message: 'Por favor, introduce actividad',
      headquarter_address_message: 'Por favor, introduce dirección de la Sede',
      success_add_toast_message: 'La empresa se ha agregado correctamente',
      success_update_toast_message: 'La empresa se ha actualizado correctamente',
      error_address_toast_message: 'Por favor, introduce oficina secundaria en dirección linea 1',
      error_country_toast_message: 'Por favor, seleccione País de oficina secundaria',
      error_state_toast_message: 'Por favor, seleccione Comunidad Autónoma de oficina secundaria',
      error_city_toast_message: 'Por favor, Ciudad de oficina secundaria',
      error_zipcode_toast_message: 'Poe favor, introduce el código postal de la sucursal',
    },
  },
  workshopAppointment: {
    pageTitle: 'Cita de taller',
    fleetRole: 'Solicitud de cita de taller',
    otherRole: 'Reservar de cita taller',
    bookNowBtn: 'Reservar ahora',
    bookAppointment: 'Reservar una cita',
    successAppointmentBookToastMessage: 'La cita de taller ha sido reservada con éxito',
    errorTimeslotToastMessage: 'Por favor, selecciona hora de la cita',
    noDataMessage: 'No hay ningún taller creado todavía',
    successBrandAddedToastMessage: 'La Marca ha sido agregada correctamente',
    successBrandUpdatedToastMessage: 'La Marca ha sido actualizada correctamente',
    errorBrandNameToastMessage: 'Por favor, introduce el nombre de la Marca',
    uploadLogo: 'Subir Logo',
    changeLogo: 'Cambiar el Logo',
    brandNamePlaceholder: 'Introduce el nombre de la marca',
    tooltipText: 'Busque por nombre de cliente, modelo de vehículo o marca.',
    tableHeaders: {
      Photos_video: 'Fotos/Video',
      invoice_pdf: 'Factura PDF',
      slot: 'Fecha y hora de la cita de taller',
      service_type: 'Tipo de servicio',
      user_details: 'Nombre del cliente',
      brand_name: 'Nombre de la marca',
      model_name: 'Modelo del Vehículo',
    },
    BookWorkshopAppointment: {
      title: 'Crear una cita de taller',
    },
    WorkshopAppointmentRequest: {
      title: 'Solicitud de cita de taller',
    },
    EditWorkshopAppointment: {
      title: 'Editar cita de taller',
    },
    menuOptions: {
      mark_as_reject: 'Marcar como rechazada',
      view_details: 'Ver detalles',
      edit: 'Editar',
      in_progress: 'En proceso',
      mark_as_complete: 'Marcar como completada',
    },
    requestsTab: 'Solicitudes de Taller',
    process: 'Procesar',
    view: 'Ver',
    date: 'Fecha',
    user: 'Usuario',
    title: 'Título',
    description: 'Descripción',
    action: 'Acción',
    noRequestsMessage: 'No se encontraron solicitudes de taller',
    newRequestsPopupTitle: 'Nuevas Solicitudes de Taller',
    newRequestsPopupMessage: 'Hay {{count}} nuevas solicitudes de taller. ¿Le gustaría verlas ahora?',
    yes: 'Sí',
    no: 'No',
    ExpandedUi: {
      customer_email: 'Email del cliente',
      customer_phone: 'Teléfono del cliente',
      customer_license_number: 'Número del Permiso de conducción del cliente',
      vehicle_plate: 'Matrícula del vehículo',
      vehicle_vin: 'Número de bastidor del vehículo',
      associated_Company: 'Empresa asociada',
      notes: 'Peticiones/anotaciones',
      service_description: 'Descripción del servicio',
      car_replacement: 'Vehículo sustitución',
      vehicle_version: 'Versión del vehículo',
      vehicle_year: 'Año del vehículo',
      no_note: 'Ninguna anotación',
      media: 'Archivos adjuntos de medios',
      reject_reason: 'Motivo del rechazo',
    },
    add_edit: {
      title: 'Cliente y características del vehículo',
      vehicle: 'vehículo',
      alert: 'Alertas',
      service_type: 'Otro tipo de servicio',
      service_description: 'Descripción del servicio',
      customer: 'Cliente',
      phone: 'Número de teléfono',
      schedule: 'Programar',
      note: 'Petición o anotación (opcional)',
      replace_Car: '¿Quieres un vehículo de sustitución?',
      appointment_timeslot: 'Selecciona hora de la cita',
      appointment_date: 'Selecciona fecha y hora de la cita',
      placeholder_service_type: 'Introducir otro tipo de servicio... ',
      placeholder_vehicle: 'Selecciona vehículo',
      placeholder_alert: 'Seleccionar alertas',
      placeholder_customer: 'Nombre del cliente',
      placeholder_email: 'Email del cliente',
      placeholder_note: 'Peticiones o anotaciones',
      error_appointment_toast_message: 'Por favor, selecciona fecha y hora de la cita',
      error_other_service_toast_message: 'Por favor, introduce otro tipo de servicio',
      error_customer_toast_message: 'Por favor, selecciona cliente',
      error_alert_toast_message: 'Por favor, selecciona alerta',
      error_service_description: 'Por favor, introduce la descripción del servicio',
      success_appointment_updated_toast_message:
        'La cita de taller se ha actualizado correctamente',
      success_appointment_created_toast_message: 'La cita de taller se ha creado correctamente',
      success_appointment_completed_toast_message: 'La cita de taller ha sido completada con éxito',
    },
    device_provider: {
      devicePlaceholder: 'Introducir el proveedor del dispositivo',
      errorDeviceProviderNameToastMessage:
        'Por favor, introducir el nombre del proveedor del dispositivo',
      successDeviceProviderNameUpdatedToastMessage:
        'El proveedor del dispositivo ha sido actualizado correctamente',
      successDeviceProviderNameAddedToastMessage:
        'El proveedor del dispositivo ha sido agregado correctamente',
    },
    steps: {
      uploadInvoiceImageLabel:
        'sube la factura o las imágenes/videos/archivos de las piezas afectadas para obtener información de la cita y como referencia para el futuro.',
      uploadFileTitle: 'Subir archivo',
      notesLabel: 'Anotaciones (Opcional)',
      notesPlaceholder: 'Introducir anotaciones...',
      complete: 'Completado',
      paymentConfirmation: 'CONFIRMACIÓN DE PAGO',
      time: 'Hora',
      createPayment: '¿Quieres crear el pago para esta cita de taller?',
      paymentConfirmationlabel: 'Confirmación de pago',
      createPaymentLabel: 'Crear pago',
      uploadInvoiceAppointmentLabel:
        'Sube la factura para obtener información de la cita y como referencia para el futuro.',
      customerName: 'Nombre del cliente',

      brandPlaceholder: 'Selecciona Marca',

      modelPLaceholder: 'Introduce modelo',
      amount: 'Importe',
      amountPlaceholder: 'Introduce importe',
      descriptionLabel: 'Descripción (Opcional)',
      descriptionPlaceholder: 'Introduce descripción...',
      successPaymentToastMessage: 'El pago se ha creado correctamente.',
      errorAmountMessage: 'Por favor, introduce importe',
    },
    success_appointment_request_send_toast_message:
      'La solicitud de cita de taller se ha enviado correctamente',
    cancelled: {
      rejectTitle: 'Cita de taller rechazada',
      reason: 'Causa',
      reasonPlaceholder: 'Causa de la cita rechazada',
      primaryButtonLabel: 'Rechazarla',
      errorResonToastMessage: 'Por favor, introducir causa',
      successRejectToastMessage: 'La cita de taller ha sido rechazada correctamente',
    },
    changeStatus: {
      changeStatusTitle: 'Cambiar el estado de la cita',
      changeStatusSubTitle: '¿Quieres cambiar el estado de',
      to: 'a',
      inProgress: 'En proceso',
      successChangeStatusToastMessage: 'El estado de la cita ha sido cambiado correctamente',
    },
    saveChanges: 'Guardar los cambios',
    addBrand: 'Agregar Marca',
    addModel: 'Agregar Modelo',
    deviceProvider: 'Proveedor del dispositivo',
    addDeviceProvider: 'Agregar proveedor del dispositivo',
    deviceProviderPlaceholder: 'Seleccionar proveedor del dispositivo',
    addDevice: 'Agregar dispositivo',
    deviceIMEI: 'Código IMEI del dispositivo.',
    errorDeviceToasterMessage: 'Por favor, Selecciona proveedor del dispositivo',
    errorIMEIToasterMessage: 'Por favor, introduce Código IMEI del dispositivo',
    successDeviceUpdateToastMessage: 'El dispositivo se ha actualizado correctamente',
    successDeviceCreateToastMessage: 'El dispositivo se ha creado correctamente',
    engine: 'Motor',
    enginePlaceholder: 'Introduce motor',
    addEngine: 'Agregar motor',
    succesEngineAddedToastMessage: 'El motor ha sido agregado correctamente',
    succesEngineUpdatedToastMessage: 'El motor ha sido actualizado correctamente',
    errorEngineToastMessage: 'Por favor, introduce motor',
    errorSelectBrandToastMessage: 'Por favor, selecciona marca',
    errorModelNameToastMessage: 'Por favor, introduce nombre del modelo',
    successModelUpdatedMessage: 'El modelo se ha actualizado correctamente',
    successModelCreatedSuccessfully: 'El modelo se ha actualizado correctamente',
  },
  alerts: {
    pageTitle: 'Alertas',
    tableHeaders: {
      alertTitle: 'Nombre de la alerta',
      dateAndTime: 'Fecha y hora',
      description: 'Descripción',
      referanceCode: 'Código de referencia',
      referanceCodePlaceholder: 'Intruduce código de referencia',
      timeLeftInDays: 'Días restantes',
    },
    alert_template_btn: 'Plantillas de Alertas',
    campaigns: 'Campañas',
    alert_Campaigns: 'Alertas y Campañas',
    noDataMessage: 'No hay ninguna alerta generada todavía',
    alertCompleteSuccess: 'La alerta ha sido completada correctamente',
    completeAlertTitle: 'Plantillas de Alertas',
    completeAlertConfirmation:
      '¿Estas seguro que quieres dar por completada la alerta {{alertTitle}}?',
    createAlert: 'Crear Alerta',
    createCampaign: 'Crear Campaña',
    programmed_alerts: 'Alertas programadas',
    noAlertTemplateCreated: 'No hay ninguna plantilla de alerta creada todavía"',
    alertupdateKm: 'actualización alerta Km',
    enterKm: 'introducir Km',
    alertUpdateDate: 'Fecha de actualización de alerta',
    saveChanges: 'Guardar cambios',
    markAsComplete: 'Marcar como completo',
    editAlert: 'Editar alerta',
    alertEditSuccess: 'Alerta editada con éxito',
    kmVal: 'Valor de kilómetros',
  },
  generated_alert: {
    tableHeaders: {
      title: 'Título',
      customer_name: 'Nombre de cliente',
      customer_number: 'Número de cliente',
      customer_email: 'Email del cliente',
      vehicle_plate: 'Matrícula del cliente',
      description: 'Descripción',
      descriptionPlaceholder: 'Descripción de la alerta',
      noDataMessage: 'Aún no hay alertas enviadas.',
    },
  },
  campaigns: {
    tableHeaders: {
      alert_ref: 'código de referencia',
      title: 'Título',
      description: 'Descripción',
      user_count: 'Cuenta de usuario',
    },
    placeholder_brand: 'Seleccionar marca ',
    placeholder_model: 'Seleccionar modelo',
    placeholder_engine: 'Seleccionar motor',
    placeholder_front_tire: 'Seleccionar medida de neumático delantero',
    placeholder_rear_tire: 'Seleccionar medida de neumático trasero',
    placeholder_tire_size: 'Seleccionar medida de neumáticos ',
    placeholder_title: 'Título de la campaña',
    placeholder_description: 'Introduce descripción...',
    campaign_title: 'Título de la campaña',
    csv_upload: 'Descarga archivo CSV con los números de bastidor de los vehículos ',
    publish_campaign_btn: 'Publicar campaña',
    title_error_message: 'Por favor, introduce el título de la campaña',
    description_error_message: 'Por favor, introduce descripción',
    referanceCode_error_message: 'por favor, introduce código de referencia',
    noDataMessage: '>Aún no se han publicado campañas',
  },
  programmed_alerts: {
    active_inactive: 'Activo/Inactivo',

    noDataMessage: 'Aún no se han creado alertas programadas.',
    conditions: 'Condiciones',
    conditionPlaceholder1: 'Selecciona campo',
    conditionPlaceholder2: 'Selecciona condición',
    primaryButtonLabel: 'Agrega nueva condición',
    errorConditionToastMessage: 'Por favor, complete el valor de las condiciones anteriores.',
    darkBtnLabel: 'Guardar como plantilla',
    editAlert: 'Editar alerta',
    createAlert: 'Crear alerta',
    conditionValueKM: 'Introduce kilómetros',
    conditionValueTime: 'Introduce días',
    conditionValueDefault: 'Introduce valor',
    errorRefCodeToastMessage: 'Por favor, introduce código de referencia de la alerta',
    errorAlertDescToastMessage: 'Por favor, introduce descripción de la alerta',
    errorAlertTitleToastMessage: 'Por favor, introduce título de la alerta',
    errorAlertToastMessage: 'Por favor, introduce título y descripción de la alerta',
    successAlertUpdateToatMessage: 'La alerta programada se ha actualizado correctamente',
    successAlterCreateToastMessage: 'La alerta programada se ha creado correctamente',
  },
  administrator_roles: {
    title: 'Roles de administrador ({{adminRoles}})',
    searchPlaceholder: 'Buscar',
    addUser: 'Agregar usuario',
    searchTooltipText: 'Buscar por nombre, apellido e email',
    add_title: 'Agregar nuevo rol de administrador',
    add_subtitle:
      'Comience completando la siguiente información para agregar un nuevo rol de administrador',
    edit_title: 'Editar rol de administrador',
    edit_subtitle:
      'Comience completando la siguiente información para editar uno nuevo rol de administrador',
    delete_title: 'Eliminar rol de administrador',
    delete_message: '¿Estás seguro que quieres eliminar el usuario {{Nombre de usuario}}?',
    successDeleteToastMessage: 'Usuario del administrador eliminado correctamente',
    noDataMessage: 'Aún no se ha creado rol de administrador',
    tableHeaders: {
      name: 'Nombre',
      last_name: 'Apellido',
      email: 'Email',
      emailPlaceholder: 'dirección de Email',
      role: 'Rol',
    },
    addEdit: {
      assignRole: 'Asignar rol',
      assignRolePlaceholder: 'Por favor, selecciona rol',
      associateCompany: 'Empresa asociada',
      associateCompanyPlaceholder: 'Por favor, selecciona empresa ',
      organizationDetail: 'Detalles de la organización',
      organization: 'Organización',
      organizationPlaceholder: 'Por favor, selecciona organización',
      selectAll: 'Seleccionar todo',
      saveChanges: 'Guardar cambios',
      addUser: 'Agregar usuario',
      add: 'Agregar',
      noOrganization: 'No hay organizaciones agregadas',
      errorNameMessage: 'Por favor introduce nombre',
      errorSurname: 'Por favor introduce apellido',
      errorEmail: 'Por favor introduce email',
      errorValidEmail: 'Por favor introduce email valido',
      errorOrganizationDetailToastMessage: 'Por favor introduce detalles de la organización',
      errorAssociateCompany: 'Por favor, selecciona empresa asociada',
      errorOrganizationToastMessage: 'Por favor, selecciona organización',
      errorParkingAddressToastMessage: 'Por favor, selecciona dirección de sucursal',
      successAddToastMessage: 'Rol de administrador creado correctamente',
      successUpdateToastMessage: 'Rol de administrador actualizado correctamente',
    },
    address: 'Dirección {{indice}}',
    noParkingAddress: 'La dirección de la sucursal no se ha agregado',
  },
  map: {
    title: 'Mapa',
    searchPlaceholder: 'Buscar por número de matrícula',
    customer: 'Cliente',
  },
  satisfactionSurvey: {
    title: 'Encuesta de satisfacción',
    searchPlaceholder: 'Buscar por nombre de cliente',
    primaryButtonLabel: 'Agregar encuesta',
    tabs: {
      surveyTemplates: 'Plantillas de encuestas',
      surveyFeedbacks: 'Respuestas de encuestas',
    },
    tableHeaders: {
      surveyTitle: 'Título de la encuesta',
      surveyType: 'Fase lanzamiento de la encuesta',
      createdAt: 'Fecha y hora',
      customerName: 'Nombre del cliente',
      customerEmail: 'Email del cliente',
      telephone: 'teléfono',
      status: 'Estado',
      view: 'Vista',
      noOfQuestions: 'Número de preguntas',
      is_activated: 'Activo/Inactivo',
    },
    feedBackTitle: 'Feedback encuesta',
    pendingToastMessage:
      'El cliente no ha contestado la encuesta. Por favor, contacta con El/Ella.',
    deleteTitle: 'Eliminar encuesta',
    deleteMesaage: '¿Estás seguro que quieres eliminar la encuesta {{encuesta}}?',
    successDeleteToastMessage: 'La encuesta se ha eliminado correctamente',
    noDataMessage: 'No hay respuestas de la encuesta disponibles.',
    export: {
      question: 'Pregunta',
      rating: 'Calificación',
      feedbackDate: 'Fecha de respuesta',
    },
    surveyDetails: {
      errorQuestionToastMessage: 'Por favor, introduce pregunta',
      errorSurveyTitleToastMessage: 'Por favor, introduce título de la encuesta',
      errorAddQuestionToastMessage: 'por favor, agrega preguntas',
      errorSurveyTypeToastMessage: 'Por favor seleccione iniciar encuesta',
      surveyEdit: 'Detalles de la encuesta',
      surveyAdd: 'Creación de encuestas',
      saveTemplate: 'Guardar como plantilla',
      surveyTitle: 'Título de la encuesta',
      surveyTitlePlaceholder: 'Da un título a tu encuesta',
      launchSurvey: 'Lanzar encuesta',
      launchSurveyPlaceholder: 'Selecciona lanzar encuesta',
      brand: 'Marcas',
      brandPlaceholder: 'Selecciona marcas',
      noDataMessage: 'Aún no se han agregado preguntas',
      questionPlaceholder: 'Da tu respuesta aquí...',
      primaryButtonLabel: 'Editar pregunta',
      addNewQuestion: 'Agregar nueva pregunta',
      addNewQuestionPlaceholder: 'Da tu respuesta aquí...',
      saveChanges: 'Guardar cambios',
      createSurvey: 'Lanzar encuesta',
      remark: 'Observaciones',
    },
  },
  users: {
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Email',
    mobileNo: 'Teléfono',
    dateOfBirth: 'Fecha de nacimiento',
    address: 'Dirección',
    action: 'Acción',
    title: 'Usuarios',
    addUser: 'Agregar usuario',
    searchPlaceholder: 'Buscar',
    searchTooltipText: 'Buscar por nombre, apellido e email',
    noUsersMessage: 'Aún no se han creado usuarios',
    assignedVehicles: 'Vehículo/s asignado/s',
    associateCompany: 'Empresa asociada',
    dni: 'NIF',
    dniExpDate: 'Fecha expedición NIF',
    licenseNo: 'Número Permiso de conducción',
    licenseExpDate: 'Fecha de expedición del permiso de conducción',
    policyNo: 'Número de póliza de seguro.',
    policyExpDate: 'Fecha de expedición de póliza de seguro',
    billingAddress: 'Dirección de facturación',
    commercialCommunication: 'Comunicación comercial',
    organization: 'Organización',
    selectVehicles: 'Por favor, selecciona vehículos',
    dniNo: 'NIF',
    expDate: 'Fecha de validez',
    enterEmail: 'Por favor, introduce email',
    enterValidEmail: 'Por favor, introduce email válido',
    enterPhone: 'Por favor, introduce teléfono',
    enterName: 'Por favor, introduce nombre',
    enterSurname: 'Por favor, introduce apellido',
    enterLicenseNo: 'Por favor, selecciona fecha expedición permiso conducción',
    fillAddressData: 'Por favor, completa todos los datos de la dirección',
    fillBillingAddressData: 'Por favor, completa todos los datos de la dirección de facturación',
    DNIDetails: 'NIF añadido por usuario en la app',
    eightDigitNo: 'Número de 8 digitos',
    drivingLicenceDetails: 'Datos del permiso de conducción',
    enterLicenceNo: 'Introduce número de permiso de conducción',
    insuranceDetails: 'Datos de la póliza de seguro',
    typeOfPurchase: 'Tipo de compra',
    selectPurchaseType: 'Por favor, selecciona tipo de compra',
    city: 'Ciudad',
    state: 'Comunidad Autónoma',
    country: 'País',
    postalCode: 'Código postal',
    import: 'Importar',
    editUser: 'Editar usuario',
    editUserSubtitle: 'Comience completando la siguiente información para editar el usuario',
    successUserDeletedToastMessage: 'Usuario eliminado correctamente',
    deleteUser: 'Eliminar usuario',
    deleteUserSubtitle: '¿Estás seguro que quieres eliminar el usuario {{nombre}}?',
    addUser: 'Agregar nuevo usuario',
    deleteUserSubtitle: 'Comience completando la siguiente información para agregar el usuario',
  },
  common: {
    confirmation: '¿Estás seguro que quieres eliminar el usuario {{nombre}}?',
    deleteSuccess: 'Usuario eliminado correctamente',
  },
  organization: {
    title: 'Organizaciones',
    add: 'Agregar organización',
    edit: 'Editar organización',
    remove: 'Quitar organización',
    searchPlaceholder: 'Buscar',
    noDataMessage: 'Aún no se ha creado la organización',
    noResultFoundMessage: 'Resultados no encontrados',
    add_title: 'Agregar organización',
    add_subtitle:
      'Comience completando la siguiente información para agregar una nueva organización',
    edit_title: 'Editar organización',
    edit_subtitle: 'Comience completando la siguiente información para editar organización',
    'Eliminar organización.título': 'Eliminar organización',
    'Eliminar organización.mensaje':
      '¿Estás seguro que quieres eliminar la organización {{Nombre de organización}}?',
    deleteSuccessMessage: 'La organización se ha eliminado correctamente',
    searchTooltipText: 'Buscar por nombre de la organización, nombre fiscal e email',
    'columns.organization_name': 'nombre de la organización',
    'columns.logo_fiscal_name': 'Logotipo y nombre fiscal',
    'columns.email': 'Email',
    'columns.telephone': 'Teléfono',
    'columns.fiscal_number': 'Número fiscal CIF',
    'columns.tax_address': 'Domicilio fiscal',
    'columns.actions': '',
    errors: {
      organization_name: 'Por favor, introduce el nombre de la organización,',
      email_required: 'Por favor, introduce email',
      invalid_email: 'Por favor, introduce email válido',
      fiscal_name_required: 'Por favor, introduce nombre fiscal',
      fiscal_number_required: 'Por favor, introduce número fiscal',
      vat_required: 'Por favor, introduce IVA',
      telephone_required: 'Por favor, introduce número de teléfono',
      invalid_telephone: 'Por favor, introduce número de teléfono válido',
      address_required: 'Por favor, introduce dirección',
      invalid_concessionaire: 'Por favor, introduce concesionario válido',
      key_required: 'Por favor, introduce key',
      secret_required: 'Por favor, introduce secret',
      resource_required: 'Por favor, introduce recurso',
      parking_address_title_required: 'Por favor, introduce el nombre de la sucursal',
      parking_address_line1_required: 'Por favor, introduce la dirección de la sucursal',
      parking_address_country_required: 'Por favor, introduce país de la sucursal',
      parking_address_state_required: 'Por favor, introduce comunidad autónoma de la sucursal',
      parking_address_city_required: 'Por favor, introduce ciudad de la sucursal',
      parking_address_zipcode_required: 'Por favor, introduce código postal de la sucursal',
      privacy_policy_url: 'Por favor proporcione una URL válida',
    },
    messages: {
      organization_added: 'Organización agregada correctamente',
      organization_updated: 'Organización actualizada correctamente',
    },
    labels: {
      upload_image: 'Subir imagen',
      change_image: 'Cambiar imagen',
      organization_name: 'Nombre de organización',
      key: 'Key',
      secret: 'Secret',
      resource: 'Recurso',
      database_name: 'Nombre de la base de datos',
      api_key: 'Clave API',
      fiscal_name: 'Nombre fiscal',
      fiscal_number: 'Número fiscal.',
      email: 'Email',
      telephone: 'Teléfono',
      address: 'Dirección',
      address_line1: 'Dirección linea 1',
      address_line2: 'Dirección linea 2',
      country: 'País',
      state: 'Comunidad autónoma',
      city: 'Ciudad',
      postal_code: 'Código postal',
      parking_address: 'Dirección de sucursal',
      concessionaire_contact: 'Contacto del concesionario (URL)',
      save_changes: 'Guardar cambios',
      add_address: 'Agregar dirección',
      no_parking_address: 'No se agrego ninguna dirección de sucursal',
      payment_keys: 'Claves de pago',
      database: 'Información de la base de datos',
      title: 'Título dirección',
      privacy_policy_url: 'URL de política de privacidad',
    },
    placeholders: {
      organization_name: 'Nombre de organización',
      key: 'Key',
      secret: 'Secret',
      resource: 'Recurso',
      database_name: 'Nombre de la base de datos',
      api_key: 'Clave API',
      fiscal_name: 'Nombre fiscal',
      fiscal_number: 'Introduce número fiscal',
      email_address: 'Email',
    },
  },
  payments: {
    title: 'Pagos',
    tableHeaders: {
      invoice_pdf: 'Factura PDF',
      customerName: 'Correo electrónico del cliente',
      slotDetails: 'Fecha y hora de la cita',
      serviceType: 'Tipo de servicio',
      amount: 'Importe',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Introduce descripción',
      brandDetails: 'Marca',
      plate: 'Lámina',
      modelDetails: 'Modelo',
      created_at: 'Fecha factura',
      payment_status: 'Estado',
      confirm: 'Confirmar',
    },
    primaryButtonLabel: 'Agregar pago',
    addPayment: {
      errorAmountToastMessage: 'Por favor, introduce importe',
      errorSelectUserToastMessage: 'Por favor, selecciona usuarios',
      errorWorkshopToastMessage: 'Por favor, selecciona taller',
      successPaymentCreatedToastMessage: 'El pago se ha realizado correctamente',

      paymentTitle: 'Agregar pago',
      createPaymentLabel: '¿Quieres realizar un pago por la cita del taller?',
      uploadInvoiceLabel:
        'Sube la factura para tener detalles de la cita y como referencia paraa el futuro.',
      fileTitle: 'Subir fichero',
      workshopLabel: 'Cita de taller',
      workshopPlaceholde: 'Selecciona cita de taller',
      customerPlaceholder: 'Selecciona cliente',
      vehicleLabel: 'Vehículo',
      vehiclePlaceholder: 'Selecciona Vehículo',
      amountPlaceholder: 'Introduce importe',
      descriptionLabel: 'Descripción (Opcional)',
      descriptionPlaceholder: 'Introduce descripción...',
      confirm: 'Confirmar',
    },
  },
  offersAndTips: {
    pageTitle: 'Ofertas y consejos',
    primaryButtonLabel: 'Crear ofertas y sugerencias',
    tableHeaders: {
      title: 'Título',
      sentAt: 'Enviado',
      organizationDetails: 'Organizaciones',
      isNotification: ' Enviar vía notificación',
      isEmail: 'Enviar vía email',
      type: 'Tipo',
      viewNotify: 'Vista usuarios notificados',
      sendAgain: 'Volver a enviar',
    },
    successOfferResentToastMessage: 'La oferta se ha reenviado correctamente',
    scheduled: 'Programado',
    sent: 'Enviado',
    addEdit: {
      saveChanges: 'Guardar cambios',
      create: 'Create',
      titlePlaceholder: 'Introduce título',
      organizationPlaceholder: 'Selecciona organizaciones',
      sendAt: 'Enviar a',
      typePlaceholder: 'Selecciona tipo',
      uploadPdf: 'Subir Pdf',
      addDesc: 'Agregar descripción',
      brandPlaceholder: 'Selecciona marca',

      enginePlaceholder: 'Selecciona motor',
      frontTirePlaceholder: 'Selecciona medida de neumáticos delanteros',
      rearTireplaceholder: 'Selecciona medida de neumáticos traseros',
      sendOfferTips: 'Enviar oferta y consejo vía ',
      pushNotification: 'Presiona notificación',
      mail: 'Correo',
      errorOfferSendToastMessage: 'Por favor, al menos una opción para enviar oferta',
      errorContentTextMessage: 'Por favor, introduce el texto del mensaje',
      errorTypeToastMessage: 'Por favor, selecciona tipo',
      errorPublishTimeToastMessage: 'Por favor, selecciona la hora de publicación',
      errorPublishDateToastMessage: 'Por favor, selecciona la fecha de publicación',
      errorSelectOrganizationToastMessage: 'Por favor, selecciona organización',
      errorTitleToastMessage: 'Por favor, introduce título',
      successOfferCreated: 'La oferta se ha creado correctamente',
    },
  },
  dms_Integartion: {
    add: 'Agregar',
    next: 'Siguiente',
    back: 'Volver',
    errorBillingAddressToastMessage:
      'Por favor, completa todos los datos de la dirección de facturación',
    errorallAddressToastMessage: 'Por favor, completa todos los datos de la dirección',
    environmentalLabel: 'Por favor, selecciona etiqueta medioambiental',
    licenseNo: 'Por favor, introduce número del permiso de conducción',
    telephoneNo: 'Por favor, introduce teléfono',
    errorFetchingDMS: 'Algo salió mal al recuperar datos de DMS',
    namePlaceholder: 'Introduce nombre',
    errorVINumberToastMessage: 'Por favor, introduce número de bastidor.',
    errorName: 'Por favor, introduce nombre',
    errorSurname: 'Por favor, introduce apellido',
    VEHICLE_DETAILS: 'Detalles del vehículo',
    USER_DETAILS: 'Detalles de usuario',
    errorNoVehicleMessage: 'El vehículo no ha sido encontrado',
  },
  sidebarListItem: {
    VEHICLES: 'Vehículos',
    USERS: 'Usuarios',
    ORGANIZATIONS: 'Organizaciones',
    COMPANIES: 'Empresas',
    WORKSHOP_APPOINTMENTS: 'Citas de Taller',
    ALERTS_CAMPAIGN: 'Alertas y Campañas',
    ADMINISTRATOR_ROLES: 'Roles de Administrador',
    MAP: 'Mapa',
    SATISFACTION_SURVEYS: 'Encuestas de Satisfacción',
    BILLING: 'Pagos',
    VEHICLE_CONFIG: 'Configurador de Vehículos',
    Offer_AND_TIPS: 'Ofertas y Consejos',
  },
  initFilter: {
    PENDING: 'PENDIENTE',
    SCHEDULED: 'PROGRAMADA',
    IN_PROGRESS: 'EN PROCESO',
    COMPLETED: 'COMPLETADA',
    CANCELED: 'CANCELADA',
  },
  NotificationType: {
    completed: 'Completado',
    warning: 'Avertencia',
    sleeping: 'Dormida',
    alert: 'Alerta',
  },
  userRoles: {
    SUPER_ADMIN: 'super_administrador',
    ADMIN: 'admin',
    DEALER_ADMIN: 'administrador_concesionario',
    CLIENT: 'cliente',
    FLEET_MANAGE: 'gestor_de_flotas',
    CALL_CENTER: 'call_center',
  },
  vehicleConfig: {
    brands: 'Marcas',
    engines: 'Motores',
    'tire-sizes': 'Medidas Neumáticos',
    'device-providers': 'Proveedores Dispositivos',
  },
  months: {
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
  },
  weekday: {
    Mon: 'Lunes',
    Tue: 'Martes',
    Wed: 'Miércoles',
    Thr: 'Jueves',
    Fri: 'Viernes',
    Sat: 'Sábado',
    Sun: 'Domingo',
  },
};
